import type { TextFieldProps } from "@mui/material/TextField";
import type { Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";
import type { FormFieldSize } from "./types";

// ------------------------------- CONSTANTS -------------------------------
export const FORM_FIELD_BASE_SX: SystemStyleObject<Theme> = {
	"& .MuiInputLabel-root": { fontSize: "0.75rem" },
	"& .MuiInputBase-input": { fontSize: "0.8125rem" },
	"& .MuiFormHelperText-root": { fontSize: "0.6875rem" },
};

export const FORM_FIELD_EXTRA_SMALL_SX: SystemStyleObject<Theme> = {
	"& .MuiInputLabel-root": { fontSize: "0.6875rem" },
	"& .MuiInputBase-root": { minHeight: 28 },
	"& .MuiInputBase-input": {
		fontSize: "0.75rem",
		paddingTop: "6px",
		paddingBottom: "6px",
	},
	"& .MuiFormHelperText-root": {
		fontSize: "0.625rem",
		marginTop: "2px",
		lineHeight: 1.2,
	},
};

export const FORM_SELECT_EXTRA_SMALL_SX: SystemStyleObject<Theme> = {
	"& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": { minHeight: 26 },
	"& .MuiSelect-select.MuiInputBase-input": {
		paddingTop: "4px",
		paddingBottom: "4px",
	},
};

// -------------------------------- HELPERS --------------------------------
export function getMuiFormFieldSize(size: FormFieldSize): Exclude<TextFieldProps["size"], undefined> {
	return size === "extraSmall" ? "small" : size;
}
